import parseAsset from './parseAsset';

const getStatusesMap = statuses =>
  statuses.reduce((map, status) => {
    map[status.id] = status;

    return map;
  }, {});

const getParsedAssetsWithStatuses = (assets, statuses) => {
  const statusesMap = getStatusesMap(statuses);

  return assets.map(parseAsset).map(asset => ({
    ...asset,
    status: statusesMap[asset.statusId]
  }));
};

export default getParsedAssetsWithStatuses;
